// extracted by mini-css-extract-plugin
export default {"separation_line_horizontal":"whiteLineSeparator_separation_line_horizontal__nz0ym"};